<div class="notification-bell">
    <span class="relative">
        <span class="badge" *ngIf="notificationCount > 0">{{notificationCount}}</span>
        <div [hidden]="!isOpen"
            class="fixed top-[90px] right-[10px] flex items-center justify-center w-[420px] p-1 transform transition-all duration-500 z-50"
            [ngClass]="{
    'opacity-100 ': isOpen,
    'opacity-0 pointer-events-none': !isOpen
  }">
            <div class="w-full max-w-md bg-white rounded-lg shadow-xl overflow-hidden">
                <!-- Header -->
                <div class="p-4">
                    <div class="flex items-center gap-3 mb-4">
                        <!-- Icon (use Heroicons, Lucide, or any SVG) -->
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-500" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M8 7V3m8 4V3m-9 8h10m-12 8h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>

                        <h2 class="text-lg font-semibold text-gray-800">Notifications</h2>

                        <button (click)="closeDropdown()"
                            class="ml-auto text-gray-400 hover:text-gray-600 transition-colors" title="Close">
                            ✕
                        </button>
                    </div>

                    <!-- Appointments List -->
                    <div class="space-y-3 max-h-64 overflow-y-auto pr-2">
                        <div *ngFor="let message of notificationMessages"
                            class="p-3 w-full border border-gray-200 flex justify-between items-center gap-1 rounded-md hover:bg-gray-50 transition-colors">
                            <!-- <p class="text-gray-700 w-[80%] text-start text-sm two-line-truncate" [title]="message?.message">{{message?.message}}
                             
                            </p> -->

                            <div class="w-[80%] flex flex-col justify-center items-center">

                                @if(message.notification_type && message.notification_type === 'Login'){

                                <!-- Text / message -->
                                <p class="text-gray-700 w-[80%] text-start text-sm two-line-truncate mt-1"
                                    [title]="message?.message">
                                    {{ message?.message }}
                                </p>

                                } @else {

                                <!-- Heading -->
                                <h3 class="font-semibold text-gray-900 text-sm">
                                    {{ message?.title || 'Appointment Updated' }}
                                </h3>

                                <h3 class="w-full font-normal text-gray-900 text-sm text-start truncate"
                                    [title]="message?.message">
                                    {{ message?.message || '' }}
                                </h3>

                                <!-- Status Change Line -->
                                <div class="flex items-center gap-2 mt-1 text-center">

                                    <!-- Old Status -->
                                    <span class="text-red-500 text-xs opacity-50">
                                        {{ message?.data?.old_status || 'Pending' }}
                                    </span>

                                    <!-- Arrow Icon -->
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-gray-400" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M5 12h14m-7-7l7 7-7 7" />
                                    </svg>

                                    <!-- New Status -->
                                    <span class="bg-green-500 text-white text-[10px] px-2 py-[2px] rounded-full">
                                        {{ message?.data?.new_status || 'Pending' }}
                                    </span>

                                </div>
                                }
                            </div>

                            <div class="flex justify-between w-[20%] items-center place-content gap-2">
                                <img [src]="assetUrl + 'icons/cross-red.svg'" alt="cross-icon" class="cursor-pointer w-7 h-7"
                                    (click)="message.notification_type === 'Login' ? clearLogin(message.id) : clearOne(message?.id)"
                                    title="clear message" />
                                <img *ngIf="message?.is_read; else singleTick" [src]="assetUrl + 'icons/tick-double.svg'"
                                    class="w-7 h-7" alt="cross-icon" />
                                <ng-template #singleTick>
                                    <img [src]="assetUrl + 'icons/tick.svg'" alt="cross-icon" title="mark as read"
                                        class="cursor-pointer w-7 h-7"
                                        (click)="message.notification_type === 'Login' ? markLoginAsRead(message.id) : markOneAsRead(message?.id)" />
                                </ng-template>
                            </div>
                        </div>

                        <div *ngIf="!notificationMessages.length" class="text-gray-500 text-sm text-center py-4">
                            No new notifications.
                        </div>
                    </div>


                </div>
                <!-- Footer -->
                <div class="flex justify-between items-center p-2 gap-5">
                    <button (click)="clearNotifications()"
                        class="w-full bg-gray-900 text-white p-1 rounded-lg  hover:bg-gray-500 transition-colors ">
                        Clear All
                    </button>
                    <button (click)="markAllAsRead()"
                        class="w-full bg-gray-200 text-gray-700 p-1 rounded-lg  hover:bg-gray-300 transition-colors ">
                        Mark All as Read
                    </button>
                </div>
            </div>
        </div>
    </span>

    <img [src]="assetUrl + 'icons/bell.svg'" alt="" (click)="openNotifications()" class="cursor-pointer" />
</div>